const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001'

export const createBurnMessage = async ({ ciphertext, iv }) => {
  const response = await fetch(`${API_URL}/api/burn-messages`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ ciphertext, iv }),
  })
  const data = await response.json()
  if (!response.ok) throw new Error(data.message || 'Não foi possível gerar o link agora.')
  return data.id
}

// Reads and deletes atomically on the server, so even two people opening
// the link at almost the same instant can't both retrieve the message.
export const consumeBurnMessage = async (id) => {
  const response = await fetch(`${API_URL}/api/burn-messages/${id}/consume`, { method: 'POST' })
  if (!response.ok) return null
  return response.json()
}
